import { styled } from 'styled-components'

export const Container = styled.div``

export const Body = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.28px;
`
export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      font-weight: 700;
      color: #7f7f7f;
    }
    svg {
      fill: #7f7f7f;
    }
  }

  p {
    font-weight: 700;
  }
`
export const List = styled.div`
  width: 100%;
  /* border: 1px solid #645a5a; */
  /* border-radius: 10px; */
  padding-bottom: 5px;
  /* border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px; */
`
export const LHead = styled.div`
  padding: 5px 8px 8px 8px;
  /* border-radius: 10px; */
  /* border-bottom-left-radius: 0px; */
  /* border-bottom-right-radius: 0px; */

  width: 100%;

  background-color: #f7f7f7;

  display: flex;
  align-items: center;
  justify-content: flex-start;
`
export const LBody = styled.div`
  padding: 0px 8px 8px 8px;
  width: 100%;
  /* height: 320px; */
  /* overflow-y: scroll; */

  > div {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`

export const ShowMore = styled.div`
  width: 100%;
  height: 30px;
  border-top: 1px solid #e6e6e6;
  padding: 10px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    margin-right: 10px;
    height: 15px;
    width: 20px;
  }
`
